module.exports = __webpack_public_path__ + "img/wx_apple_bc@2x.be48ab2d.png";